export const modelHasStructuralElements = (model: PlanarModel): boolean =>
  model.walls.length > 0 ||
  model.slabs.length > 0 ||
  model.roof_slabs.length > 0 ||
  model.vertical_slabs.length > 0 ||
  model.vertical_roof_slabs.length > 0 ||
  model.beams.length > 0 ||
  model.purlins.length > 0 ||
  model.columns.length > 0 ||
  model.rips.length > 0 ||
  model.lintels.length > 0
